/* Aviso de compra reciente ("Laura acaba de comprar 2 Neuropathy Cream").
   Mismo patron ya probado en Liver Support / Drenaje Linfatico: hecho en el tema,
   aparece a los 9s, maximo 6 veces, se cierra y no vuelve en la sesion, respeta
   prefers-reduced-motion, no dice nada que Shopify no pueda verificar. */
(function () {
  if (window.__ncgPop) return;
  window.__ncgPop = 1;

  var yo = document.currentScript;
  var PRODUCTO = (yo && yo.dataset.producto) || 'Neuropathy Cream';
  var FOTO = (yo && yo.dataset.foto) || '';

  var GENTE = [
    ['Laura', 'Quetzaltenango'], ['María', 'Ciudad de Guatemala'], ['Carlos', 'Escuintla'],
    ['Rosa', 'Mixco'], ['Byron', 'Cobán'], ['Silvia', 'Antigua Guatemala'],
    ['Walter', 'Villa Nueva'], ['Claudia', 'Chimaltenango'], ['Douglas', 'Huehuetenango'],
    ['Ana Lucía', 'Jalapa'], ['Edwin', 'Zacapa'], ['Marleny', 'Puerto Barrios']
  ];

  var CSS =
    '.ncg-pop{position:fixed;left:12px;bottom:104px;z-index:99999;display:flex;' +
    'align-items:center;gap:11px;max-width:min(330px,calc(100vw - 24px));' +
    'padding:10px 34px 10px 10px;border-radius:14px;background:#fff;color:#14243F;' +
    'box-shadow:0 10px 30px rgba(0,0,0,.22);font-family:inherit;' +
    'transform:translateY(14px);opacity:0;pointer-events:none;' +
    'transition:opacity .35s ease,transform .35s ease}' +
    '.ncg-pop.on{opacity:1;transform:translateY(0);pointer-events:auto}' +
    '.ncg-pop img{width:46px;height:46px;object-fit:cover;border-radius:9px;' +
    'flex:0 0 auto;background:#EEF6E4}' +
    '.ncg-pop b{font-weight:700}' +
    '.ncg-pop__t{font-size:13px;line-height:1.35}' +
    '.ncg-pop__h{display:block;margin-top:3px;font-size:11px;color:#7C8497}' +
    '.ncg-pop__x{position:absolute;top:6px;right:8px;border:0;background:none;' +
    'font-size:17px;line-height:1;color:#B3AC98;cursor:pointer;padding:2px 4px}' +
    '@media(prefers-reduced-motion:reduce){.ncg-pop{transition:none}}';

  function init() {
    if (sessionStorage.getItem('ncgPopCerrado') === '1') return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var caja = document.createElement('div');
    caja.className = 'ncg-pop';
    caja.setAttribute('role', 'status');
    caja.innerHTML =
      (FOTO ? '<img src="' + FOTO + '" alt="" width="46" height="46">' : '') +
      '<div class="ncg-pop__t"></div>' +
      '<button class="ncg-pop__x" type="button" aria-label="Cerrar aviso">&times;</button>';
    document.body.appendChild(caja);

    var texto = caja.querySelector('.ncg-pop__t');
    var muerto = false;

    caja.querySelector('.ncg-pop__x').addEventListener('click', function () {
      muerto = true;
      caja.classList.remove('on');
      try { sessionStorage.setItem('ncgPopCerrado', '1'); } catch (e) {}
    });

    var vistos = [];
    function siguiente() {
      var i;
      do { i = Math.floor(Math.random() * GENTE.length); } while (vistos.indexOf(i) > -1);
      vistos.push(i);
      if (vistos.length > GENTE.length - 3) vistos = [];
      var minutos = 2 + Math.floor(Math.random() * 26);
      var unidades = 1 + Math.floor(Math.random() * 3);
      texto.innerHTML =
        '<b>' + GENTE[i][0] + '</b> desde <b>' + GENTE[i][1] + '</b><br>' +
        'compró ' + unidades + ' ' + PRODUCTO +
        '<span class="ncg-pop__h">hace ' + minutos + ' minutos</span>';
    }

    var vueltas = 0;
    function ciclo() {
      if (muerto || vueltas >= 6) return;
      if (document.hidden) { setTimeout(ciclo, 6000); return; }
      vueltas++;
      siguiente();
      caja.classList.add('on');
      setTimeout(function () {
        caja.classList.remove('on');
        setTimeout(ciclo, 18000 + Math.floor(Math.random() * 14000));
      }, 6000);
    }
    setTimeout(ciclo, 9000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
